import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // 아직 로그인 상태 확인 중이면 아무것도 렌더링 안 함
  if (loading) {
    return null; // 또는 로딩 스피너
  }

  // 로그인 안 되어 있으면 로그인 페이지로 이동
  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location }} // 로그인 후 복귀용
      />
    );
  }

  return children;
};

export default PrivateRoute;
